import React, { Fragment } from "react";
import { observer } from "mobx-react";
import { http } from "../../services/HttpInterceptor";
import { RouteComponentProps, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { observable, computed } from "mobx";
import InputForm from "../site/layout/InputForm";
import { sessionService } from "../../services/SessionService";
import swal from "sweetalert";

interface InstallmentProps extends RouteComponentProps {
  changeToggle(action?: boolean): void;
}

@observer
export default class Installments extends React.Component<InstallmentProps> {
  @observable private contract: any;
  @observable private isLoaded = false;
  @observable private redirect = false;
  @observable private num_meses: any = 3;
  @observable private validationErrors: string[] = ["due_balance"];
  @computed get monthlyOptions() {
    if (!this.contract || !this.contract.due_balance) {
                  return [
                { id: '3', name: "x3 meses" },
                { id: '6', name: "x6 meses" },
                { id: '9', name: "x9 meses" },
                { id: '12', name: "x12 meses" },
            ];
    }

    const saldoDeudor = this.contract.due_balance;
            return [
            { id: '3', name: `x3 meses - $${Math.ceil(saldoDeudor / 3)} por mes` },
            { id: '6', name: `x6 meses - $${Math.ceil(saldoDeudor / 6)} por mes` },
            { id: '9', name: `x9 meses - $${Math.ceil(saldoDeudor / 9)} por mes` },
            { id: '12', name: `x12 meses - $${Math.ceil(saldoDeudor / 12)} por mes` },
        ];
  }
  componentDidMount() {
    this.props.changeToggle(true);
    this.init();
  }

  init = () => {
    const match = this.props.match;
    const id = (match as any).params.id;

    http
      .get(`/api/contract/read/${id}`)
      .then((response) => {
        this.contract = response.data;
        if (this.contract.due_balance !== 0) {
          this.validationErrors = [];
        }
      })
      .then(() => {
        this.isLoaded = true;
      })
      .catch((error) => {
        toast.error("Error cargando Informacion");
      });
  };

  private handleChange = (event: any) => {
    const { value } = event.target;
    this.num_meses = value;
  };

  private crearPlanPagos = () => {
    const montoMensual = Math.ceil(this.contract.due_balance / this.num_meses);
    
    swal({
      title: "¿Estás seguro?",
      text: `¿Quieres crear un plan de pagos de ${this.num_meses} meses con un pago mensual de $${montoMensual}?`,
      icon: "warning",
      buttons: ["Cancelar", "Crear plan"],
      dangerMode: true,
    }).then((willCreate) => {
      if (willCreate) {
        http.post(`/api/contract/create_installment`, {
          contract_id: this.contract.id,
          num_meses: this.num_meses,
          total: this.contract.due_balance,
          pagos_pendientes: this.num_meses,
          created_by: sessionService.getUserInfo().id,
        }).then((response) => {
          toast.success("Plan de pagos creado correctamente");
          this.redirect = true;
        }).catch((error) => {
            toast.error("Error al crear el plan de pagos");
            console.log(error);
        });
      }
    });
  };

  private setValidation = (value: boolean, name: string): void => {
    const error = this.validationErrors.indexOf(name);
    if (value && error === -1) {
      this.validationErrors.push(name);
    } else if (!value && error !== -1) {
      this.validationErrors.splice(error, 1);
    }
  };

  render() {
    if (!this.isLoaded) {
      return null;
    }
    if (this.redirect) {
      return <Redirect to={`/contratos/ver/${this.contract.id}`} />;
    }
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header card-header-rose card-header-text">
                <div className="card-text">
                  <h4 className="card-title">
                    Diferir saldo deudor a meses:{" "}
                    {this.contract && this.contract.id}
                  </h4>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <h5>Saldo deudor: ${this.contract.due_balance}</h5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <InputForm
                      name="num_meses"
                      label="Número de meses a diferir"
                      value={this.num_meses}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="select"
                      options={this.monthlyOptions}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 text-right">
                    <button
                      type="button"
                      className="btn btn-primary btn-round"
                      onClick={this.crearPlanPagos}
                    >
                      <i className="material-icons">payment</i>
                      Crear plan de pagos
                    </button>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
